<script lang="ts" setup>
import { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/vue';

defineProps<{ title: string; description: RichTextField; id: number }>();
</script>
<template>
  <h3
    :id="'title__' + id"
    class="ksp-block__title"
    data-testid="kspBlockItemTitle"
  >
    {{ title }}
  </h3>
  <PrismicRichText
    :id="'paragraph__' + id"
    class="ksp-block__paragraph"
    data-testid="kspBlockItemDescription"
    :field="description"
  />
</template>
